export default "__VITE_ASSET__DFb5Xti3__"